import React from 'react';
import { fromPairs, pipe, range, take } from 'ramda';
import { scaleOrdinal } from '@vx/scale';

import { mapIndexed } from '../../../utils/mapIndexed';
import { Legend } from '../charts.styles';

export const PieLegend = ({ label, data, reverse, config }) => {
  const count = data.length;

  const domain = range(0, count);
  const rangeScale = take(count, config.colors);

  if (reverse) {
    domain.reverse();
    rangeScale.reverse();
  }

  const color = scaleOrdinal({ domain, range: rangeScale });
  const labels = pipe(
    mapIndexed((item, index) => [index, item[label]]),
    fromPairs
  )(data);

  return <Legend colorScale={color} labels={labels} />;
};
